import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun WelcomeScreen(
    onNavigate: (Screen) -> Unit,
    onLogout: () -> Unit
) {
    Div({
        style {
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            alignItems(AlignItems.Center)
            justifyContent(JustifyContent.Center)
            minHeight(100.vh)
            backgroundColor(Color("#f8f9fa"))
            padding(20.px)
            // Важно для позиционирования кнопки внутри этого блока
            position(Position.Relative)
        }
    }) {
        Button({
            onClick { onNavigate(Screen.ADMIN_GENERATOR) }
            style { marginTop(10.px); marginLeft(10.px) }
        }) { Text("Admin SQL Tool") }
        // --- НОВОЕ МЕСТО КНОПКИ СТАТИСТИКИ ---
        Button({
            style {
                // Абсолютное позиционирование в правом верхнем углу
                position(Position.Absolute)
                top(20.px)
                right(20.px)

                // Стили кнопки
                padding(10.px, 20.px)
                backgroundColor(Color("#8e44ad")) // Фиолетовый
                color(Color.white)
                border(0.px)

                // Прямоугольная форма (немного скругленная для красоты)
                borderRadius(6.px)

                cursor("pointer")
                fontWeight("bold")
                property("box-shadow", "0 2px 5px rgba(0,0,0,0.2)")
            }
            onClick { onNavigate(Screen.STATISTICS) }
        }) {
            Text("📊 Ver mis Estadísticas")
        }

        // --- ОСТАЛЬНОЙ КОНТЕНТ ---

        // Заголовок
        H1({ style { color(Color("#2c3e50")); marginBottom(10.px) } }) {
            Text("¡Hola! ¿Qué practicamos hoy?")
        }
        P({ style { color(Color("#7f8c8d")); marginBottom(40.px); fontSize(1.2.cssRem) } }) {
            Text("Selecciona una habilidad para empezar")
        }

        // Контейнер для карточек (Grid или Flex)
        Div({
            style {
                display(DisplayStyle.Flex)
                property("gap", "30px")
                property("flex-wrap", "wrap") // Чтобы на мобильных переносилось
                justifyContent(JustifyContent.Center)
                width(100.percent)
                maxWidth(900.px)
            }
        }) {
            // КАРТОЧКА 1: ЧТЕНИЕ (Lectura)
            ModeCard(
                title = "Comprensión de Lectura",
                icon = "📖",
                description = "Textos, artículos y tareas de gramática.",
                color = "#3498db", // Синий
                onClick = { onNavigate(Screen.READING_MENU) }
            )

            // КАРТОЧКА 2: АУДИРОВАНИЕ (Auditiva)
            ModeCard(
                title = "Comprensión Auditiva",
                icon = "🎧",
                description = "Escucha grabaciones y responde preguntas.",
                color = "#f1c40f", // Желтый
                onClick = {
                    onNavigate(Screen.LISTENING_MENU)
                }
            )
        }

        // Кнопка Выхода (внизу)
        Button({
            style {
                marginTop(50.px)
                padding(10.px, 20.px)
                backgroundColor(Color.transparent)
                border(1.px, LineStyle.Solid, Color("#e74c3c"))
                color(Color("#e74c3c"))
                borderRadius(6.px)
                cursor("pointer")
            }
            onClick { onLogout() }
        }) {
            Text("Cerrar Sesión")
        }
    }
}

@Composable
fun ModeCard(
    title: String,
    icon: String,
    description: String,
    color: String,
    onClick: () -> Unit
) {
    Div({
        onClick { onClick() }
        style {
            backgroundColor(Color.white)
            width(300.px)
            padding(30.px)
            borderRadius(16.px)
            property("box-shadow", "0 10px 25px rgba(0,0,0,0.05)")
            cursor("pointer")
            property("transition", "transform 0.2s, box-shadow 0.2s")
            display(DisplayStyle.Flex)
            flexDirection(FlexDirection.Column)
            alignItems(AlignItems.Center)
            textAlign("center")
            border(2.px, LineStyle.Solid, Color.transparent)
        }
        // Эффект наведения через JS
        attr("onmouseover", "this.style.transform='translateY(-5px)'; this.style.boxShadow='0 15px 30px rgba(0,0,0,0.1)'; this.style.borderColor='$color'")
        attr("onmouseout", "this.style.transform='translateY(0)'; this.style.boxShadow='0 10px 25px rgba(0,0,0,0.05)'; this.style.borderColor='transparent'")
    }) {
        // Иконка
        Div({
            style {
                fontSize(4.cssRem)
                marginBottom(20.px)
            }
        }) { Text(icon) }

        // Заголовок
        H3({ style { margin(0.px); marginBottom(10.px); color(Color("#2c3e50")) } }) { Text(title) }

        // Описание
        P({ style { color(Color("#95a5a6")); lineHeight("1.5em") } }) { Text(description) }

        // Кнопка "Начать" внутри карточки
        Div({
            style {
                marginTop(20.px)
                color(Color(color))
                fontWeight("bold")
            }
        }) { Text("Entrar →") }
    }
}